// material-ui

import batchtripcreationicon from '../../../assets/images/batch-trip-creation.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const BatchTripCreationIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={batchtripcreationicon} alt="Batch Trip Creation" width="22"  />
    );
};

export default BatchTripCreationIcon;